import React, { FC } from 'react';

import { TextProps } from 'antd/lib/typography/Text';
import { TitleProps } from 'antd/lib/typography/Title';
import { LinkProps } from 'antd/lib/typography/Link';
import { ParagraphProps } from 'antd/lib/typography/Paragraph';

import { Props } from './types';
import { StyledText } from './styled';

export const Text: FC<TextProps> = (props) => <Text {...props} />;
export const Title: FC<TitleProps> = (props) => <Title {...props} />;
export const Link: FC<LinkProps> = (props) => <Link {...props} />;
export const Paragraph: FC<ParagraphProps> = (props) => (
  <Paragraph {...props} />
);

export const Typography = ({
  as,
  children,
  color = 'darkGrey',
  variant,
  weight = 'Regular',
  ...rest
}: Props<typeof as>) => {
  const Component = as || 'span';

  return (
    <StyledText
      variant={variant}
      weight={weight}
      color={color}
      as={Component}
      {...rest}
    >
      {children}
    </StyledText>
  );
};
